// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "card-3p0aP";
var _3 = "header-FXf84";
var _4 = "document-l3Z67";
var _5 = "title-1ORql";
var _6 = "subtitle-1994K";
var _7 = "content-3NdwJ";
var _8 = "content__item-PZaxR";
var _9 = "content__item__name-1EWG0";
var _a = "content__item__value-1ZKvz";
var _b = "footer-2Sq26";
var _c = "footer__button-3-wNB";
var _d = "button__label-3-eao";
var _e = "card_loyalty-1nU89";
var _f = "card_dummy-8cv3C";
var _10 = "modal__content-3h0FI";
export { _1 as "__esModule", _2 as "card", _3 as "header", _4 as "document", _5 as "title", _6 as "subtitle", _7 as "content", _8 as "content__item", _9 as "content__item__name", _a as "content__item__value", _b as "footer", _c as "footer__button", _d as "button__label", _e as "card_loyalty", _f as "card_dummy", _10 as "modal__content" }
export default { "__esModule": _1, "card": _2, "header": _3, "document": _4, "title": _5, "subtitle": _6, "content": _7, "content__item": _8, "content__item__name": _9, "content__item__value": _a, "footer": _b, "footer__button": _c, "button__label": _d, "card_loyalty": _e, "card_dummy": _f, "modal__content": _10 }
